/**
 * TKP-208 — çalışma alanı kütüphanesini Excel'den yükleme: uç yolları ve rapor özeti. Saf.
 * `mode`: "management" (yönetici paneli; çalışma alanı gövdede) | "workspace" (çalışma alanı sahibi; başlıktan).
 */
export const importPaths = (mode) => (mode === "management" ? { template: "/management/workspace/library/import/template", upload: "/management/workspace/library/import" } : { template: "/workspace/library/import/template", upload: "/workspace/library/import" });

/** Yükleme gövdesi: dosya + payload (JSON). */
export const uploadForm = (file, { workspace, dryRun }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("payload", JSON.stringify({ ...(workspace ? { workspace } : {}), dryRun: !!dryRun }));
  return form;
};

/** Tablo satırları: yalnız dosyada bulunan sayfalar; hata/tekrar satırları açılır liste için. */
export const reportRows = (report) =>
  ((report && report.sheets) || []).map((s) => ({ sheet: s.sheet, rows: s.rows, created: s.created, existing: s.existing, duplicates: (s.duplicates || []).length, errors: (s.errors || []).length, problems: [...(s.errors || []).map((e) => ({ ...e, kind: "error" })), ...(s.duplicates || []).map((e) => ({ ...e, kind: "duplicate" }))].sort((a, b) => a.row - b.row) }));

/**
 * TKP-247 — Excel'e indirme seçenekleri: yönetici panelinde Tunesoft kütüphanesi (+ çalışma alanı seçiliyse onun kütüphanesi),
 * çalışma alanı sahibinin sayfasında kendi kütüphanesi. Her biri: { key, url, filename }.
 */
export const exportTargets = (mode, workspaceId) =>
  mode === "management"
    ? [
        { key: "tunesoft", url: "/management/workspace/library/export", filename: "tunesoft-kutuphanesi.xlsx" },
        ...(workspaceId ? [{ key: "workspace", url: `/management/workspace/library/export?workspace=${workspaceId}`, filename: "calisma-alani-kutuphanesi.xlsx" }] : []),
      ]
    : [{ key: "workspace", url: "/workspace/library/export", filename: "calisma-alani-kutuphanesi.xlsx" }];
